export default __webpack_public_path__ + "static/media/exclamation.c13f29d0.svg";